import React from "react";
import { planningSteps } from "../data/steps";
import { SectionCTA } from "./SectionCTA";
export function TransformationSection() {
  return <section className="bg-canvas px-4 py-16 md:py-24" data-id="element-307" data-mp="31xi7yd3dguau">
      <div className="mx-auto max-w-5xl" data-id="element-308" data-mp="2wwum05u033nh">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-16" data-id="element-309" data-mp="2wvsz943mgspx">
          <div className="text-center lg:sticky lg:top-10 lg:self-start lg:text-left" data-id="element-310" data-mp="2rxrd2aawgda8">
            <p className="text-sm font-bold uppercase tracking-wider text-brand" data-id="element-311" data-mp="2ny0rqm456pd3">The measurable transformation</p>
            <h2 className="mt-3 font-serif text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-312" data-mp="2j5h4syjkehvm">
              Organize your next case into a clear visual strategy in approximately
            </h2>
            <p className="mt-4 font-serif text-7xl font-black text-brand md:text-8xl" data-id="element-313" data-mp="299mgpnwknulg">
              15<span className="ml-2 text-3xl font-extrabold text-ink md:text-4xl" data-id="element-314" data-mp="247ormd1hq5kl">minutes</span>
            </p>
            <p className="mt-5 text-lg text-muted" data-id="element-315" data-mp="207wmkabb2hjz">
              Instead of jumping between different pieces of information, you'll work through a structured sequence:
            </p>
          </div>

          <ol className="relative space-y-3" data-id="element-316" data-mp="k33s2i6lv1yx">
            <span className="absolute bottom-6 left-[27px] top-6 w-0.5 bg-navy-900/10" aria-hidden="true" data-id="element-317" data-mp="5d670b3z2sdy" />
            {planningSteps.map(step => <li key={step.number} className="relative flex items-center gap-4 rounded-2xl bg-white p-3 pr-4 shadow-sm ring-1 ring-navy-900/5" data-id="element-318" data-mp="ac95tdtd02dh">
                <span className={`grid h-[44px] w-[44px] shrink-0 place-items-center rounded-xl text-xl font-black text-white ${step.color}`} data-id="element-319" data-mp="1316mxdlu3t4n">
                  {step.number}
                </span>
                <div data-id="element-320" data-mp="t27f1x8w81ip">
                  <p className="text-base font-extrabold uppercase tracking-wide text-ink" data-id="element-321" data-mp="t1frn9pg9a3i">{step.title}</p>
                  <p className="text-[15px] leading-snug text-muted" data-id="element-322" data-mp="39qbgmnt5h70o">{step.text}</p>
                </div>
              </li>)}
          </ol>
        </div>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-323" data-mp="1k9poemp6paht">
          <p className="text-lg text-muted" data-id="element-324" data-mp="1kc23ms3k56r6">The goal isn't to replace your clinical judgment.</p>
          <p className="mt-2 font-serif text-2xl font-extrabold text-ink md:text-3xl" data-id="element-325" data-mp="1fbo2zv4acz36">
            The goal is to give your clinical judgment <em className="text-brand" data-id="element-326" data-mp="15lcpphyppdjm">a structure to work with.</em>
          </p>
        </div>

        <SectionCTA label="I want a structure for my clinical judgment" data-id="element-327" data-mp="11jhn8a51ou49" />
      </div>
    </section>;
}